var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"title",class:{ 'title--reverse': _vm.reverseColors }},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('br'),_c('span',{staticClass:"subtitle",class:{ 'subtitle--reverse': _vm.reverseColors },domProps:{"innerHTML":_vm._s(_vm.subtitle)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }